import { Navigate } from 'react-router-dom'

import { buildAppMode } from '@/shared/buildMode'

export function RootRedirect() {
  const target = buildAppMode === 'delman' ? '/delman' : '/kitchen'
  return <Navigate to={target} replace />
}
